import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import Icon from "../Icon";
import { SERVICES } from "../../data";
import { Reveal } from "../Reveal";

export default function ServicesGrid() {
  return (
    <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
      {SERVICES.map((s, i) => (
        <Reveal key={s.key} delay={i * 0.06}>
          <motion.div
            whileHover={{ y: -6 }}
            transition={{ type: "spring", stiffness: 300, damping: 20 }}
            className="group relative h-full overflow-hidden rounded-2xl border border-white/10 bg-white/[0.03] p-8 backdrop-blur-xl transition-colors duration-300 hover:border-blue-500/50"
            data-testid={`service-card-${s.key}`}
          >
            <div className="pointer-events-none absolute -right-16 -top-16 h-40 w-40 rounded-full bg-blue-600/10 blur-3xl transition-opacity duration-300 opacity-0 group-hover:opacity-100" />
            <div className="flex items-center justify-between">
              <div className="flex h-12 w-12 items-center justify-center rounded-xl border border-white/10 bg-blue-600/10 text-blue-400">
                <Icon name={s.icon} className="h-6 w-6" />
              </div>
              <ArrowUpRight className="h-5 w-5 text-slate-600 transition-colors duration-300 group-hover:text-blue-400" />
            </div>
            <h3 className="mt-6 font-display text-xl font-medium tracking-tight">{s.title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-slate-400">{s.desc}</p>
          </motion.div>
        </Reveal>
      ))}
    </div>
  );
}
